<template>
  <modal
    name="poll-vote-detail-modal"
    :click-to-close="true"
    :width="660"
    height="auto"
    class="modal-custom poll-vote-detail-modal-wrap"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <vue-element-loading :active="loading" spinner="bar-fade-scale" />
    <div class="poll-vote-detail-modal" v-if="pollId || localOptions.length">
      <div class="poll-vote-detail-modal__header">
        <div class="poll-vote-detail-modal__title">Chi tiết bình chọn</div>
        <button type="button" class="poll-vote-detail-modal__close" @click="$modal.hide('poll-vote-detail-modal')">
          <span class="material-icons">close</span>
        </button>
      </div>

      <div class="poll-vote-detail-modal__body custom-scroll-bar-2" ref="detailBody">
        <div
          v-for="(option, index) in localOptions"
          :key="'detail-opt-' + index"
          class="poll-vote-detail-modal__section"
          :ref="'section-' + index"
        >
          <div class="poll-vote-detail-modal__section-title">
            {{ option.answer }} ({{ option.vote_ids?.length || 0 }})
          </div>

          <div
            v-if="optionUsers(option).length"
            class="poll-vote-detail-modal__grid"
          >
            <div
              v-for="(user, ui) in visibleUsers(option, index)"
              :key="'detail-user-' + index + '-' + ui"
              class="poll-vote-detail-modal__user"
            >
              <image-template
                :thumbnail="user.thumbnail"
                :image="user.avatar"
                :name="userLabel(user)"
                size="small"
                width="36px"
                height="36px"
                class="poll-vote-detail-modal__avatar"
              />
              <span class="poll-vote-detail-modal__name">{{ userLabel(user) }}</span>
            </div>
          </div>

          <div v-else class="poll-vote-detail-modal__empty">Chưa có lượt bình chọn</div>

          <button
            v-if="shouldShowSectionExpand(option, index)"
            type="button"
            class="poll-vote-detail-modal__expand"
            @click="expandSection(index)"
          >
            Xem thêm
          </button>
        </div>
      </div>

      <div class="poll-vote-detail-modal__footer">
        <button
          type="button"
          class="poll-vote-detail-modal__close-btn"
          @click="$modal.hide('poll-vote-detail-modal')"
        >
          Đóng
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import ChatService from '@/store/services/ChatService';
import ImageTemplate from '@/components/ImageTemplate.vue';

const SECTION_PREVIEW_LIMIT = 9;

export default {
  name: 'PollVoteDetailModal',
  components: {
    ImageTemplate,
  },
  data() {
    return {
      loading: false,
      pollId: null,
      sourceMess: null,
      localOptions: [],
      focusOptionIndex: null,
      expandedSections: {},
    };
  },
  methods: {
    beforeOpen(event) {
      this.pollId = event.params?.pollId || null;
      this.sourceMess = event.params?.sourceMess || null;
      this.focusOptionIndex = event.params?.focusOptionIndex ?? null;
      this.expandedSections = {};
      const options = event.params?.localOptions;
      if (options?.length) {
        this.localOptions = this.normalizePollOptions(options);
      }
      if (this.pollId) {
        this.fetchPollDetail(this.pollId);
      }
    },
    beforeClose() {
      this.pollId = null;
      this.sourceMess = null;
      this.localOptions = [];
      this.focusOptionIndex = null;
      this.expandedSections = {};
    },
    normalizePollOptions(data) {
      const list = Array.isArray(data) ? data : Object.values(data || {});
      return list.map((item) => ({ ...item }));
    },
    optionUsers(option) {
      if (option?.users?.length) {
        return option.users;
      }
      return (option?.vote_ids || []).map((id) => ({ id }));
    },
    userLabel(user) {
      return user.display_name || user.fullname || user.name || 'Người dùng';
    },
    visibleUsers(option, index) {
      const users = this.optionUsers(option);
      if (this.expandedSections[index]) {
        return users;
      }
      return users.slice(0, SECTION_PREVIEW_LIMIT);
    },
    shouldShowSectionExpand(option, index) {
      const users = this.optionUsers(option);
      return users.length > SECTION_PREVIEW_LIMIT && !this.expandedSections[index];
    },
    expandSection(index) {
      this.$set(this.expandedSections, index, true);
    },
    async fetchPollDetail(pollId) {
      this.loading = true;
      try {
        const res = await ChatService.getPollDetail(pollId);
        if (res?.status && res.data?.data) {
          this.localOptions = this.normalizePollOptions(res.data.data);
        }
        this.scrollToFocusSection();
      } finally {
        this.loading = false;
      }
    },
    scrollToFocusSection() {
      if (this.focusOptionIndex == null) return;
      this.$nextTick(() => {
        const ref = this.$refs[`section-${this.focusOptionIndex}`];
        const el = Array.isArray(ref) ? ref[0] : ref;
        if (el && this.$refs.detailBody) {
          const body = this.$refs.detailBody;
          body.scrollTop = Math.max(0, el.offsetTop - 12);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.poll-vote-detail-modal {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
}

.poll-vote-detail-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #e9eaec;
}

.poll-vote-detail-modal__title {
  font-size: 18px;
  font-weight: 600;
  color: #26282c;
}

.poll-vote-detail-modal__close {
  border: 0;
  background: transparent;
  cursor: pointer;
  color: #65686c;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin-left: auto;
}

.poll-vote-detail-modal__body {
  max-height: 70vh;
  overflow-y: auto;
  padding: 16px 20px 8px;
}

.poll-vote-detail-modal__section + .poll-vote-detail-modal__section {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #f1f2f4;
}

.poll-vote-detail-modal__section-title {
  font-size: 15px;
  font-weight: 700;
  line-height: 1.4;
  color: #26282c;
  margin-bottom: 12px;
}

.poll-vote-detail-modal__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px 12px;
}

.poll-vote-detail-modal__user {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.poll-vote-detail-modal__avatar {
  flex: 0 0 auto;
}

.poll-vote-detail-modal__avatar :deep(.image-template) {
  width: 36px;
  height: 36px;
}

.poll-vote-detail-modal__name {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  line-height: 16px;
  color: #26282c;
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}

.poll-vote-detail-modal__empty {
  font-size: 13px;
  color: #8a8d91;
}

.poll-vote-detail-modal__expand {
  display: block;
  margin: 12px auto 0;
  appearance: none;
  -webkit-appearance: none;
  border: 1px solid #bcc0c4;
  border-radius: 999px;
  background: transparent;
  color: #26282c;
  font-size: 14px;
  font-weight: 500;
  padding: 6px 18px;
  cursor: pointer;
}

.poll-vote-detail-modal__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 12px 20px 16px;
  border-top: 1px solid #e9eaec;
}

.poll-vote-detail-modal__close-btn {
  min-width: 96px;
  height: 40px;
  border: 0;
  border-radius: 8px;
  background: #f1f2f4;
  color: #26282c;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
</style>
